module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/hotdrink-left-icon-129ef29ffe5bda7ed37b4efb110c7c50.svg";